import React from 'react';
import { Component } from 'react';
import './StatusScreen.scss';
import premiumActiveImg from '../../../content/status/premium-active.png';
import premiumNotActiveImg from '../../../content/status/premium-not-active.png';
import apiRoutingService from '../../../services/apiRoutingService';
import RoutingService from '../../../services/routingService';

type StartScreenProps = {
    usrId: number;
    usrLogin: string;
};

type StartScreenState = {
    expDate: Date;
    isRecurring: boolean;
    isActive: boolean;
};

export default class StartScreen extends Component<StartScreenProps, StartScreenState> {
    constructor(props: StartScreenProps) {
        super(props);

        this.state = {
            expDate: new Date(),
            isRecurring: false,
            isActive: false
        };
    }

    async componentDidMount() {
        try {
            const userData = await apiRoutingService.getUserData();


            var date = new Date(userData.subscriptionEndsAt);

            this.setState({
                expDate: new Date(userData.subscriptionEndsAt),
                isActive: new Date(userData.subscriptionEndsAt) > new Date(),
                isRecurring: userData.hasRecurring
            });
        } catch (error) {
            console.error("Błąd podczas pobierania danych użytkownika:", error);
        }
    }

    public render() {
        return (
            <div className="status-container">
                <h1 className='title'>Witaj {this.props.usrLogin}</h1>

                <h2 className='subtitle'>Stan Twojego konta</h2>

                {(() => {
                    if (this.state.isActive) {
                        let activeText = "Aktywne";
                        let descActive = "Dostęp do Mediti Premium aktywny do " + this.state.expDate.toLocaleString();
                        let descRenew = "";

                        if (this.state.isRecurring) {
                            descActive = "Dostęp do Mediti Premium aktywny";
                            descRenew = "odnowienie nastąpi " + this.state.expDate.toLocaleString();
                        }

                        return (
                            <div>
                                <div className="premium-status-img">
                                    <img src={premiumActiveImg} alt="premium-active" />
                                </div>

                                <p className='premium-active-text'>{activeText}</p>

                                <p className='premium-desc'>{descActive}</p>
                                <p className='premium-desc'>{descRenew}</p>
                            </div>
                        )
                    }

                    return (
                        <div>
                            <div className="premium-status-img">
                                <img src={premiumNotActiveImg} alt="premium-not-active" />
                            </div>

                            <p className='premium-not-active-text'>Nieaktywne</p>

                            <p className='premium-desc'>Sprawdź <a href={RoutingService.getPriceListPageRoute()}>nasz cennik</a> i wybierz subskrypcję pasującą do Ciebie</p>
                        </div>
                    )
                })()}

            </div>
        )
    }
}